import * as Yup from 'yup';

import {
  EIV_CHAR_LENGTH,
  EIV_ENTRY_TYPE,
  TENANT_WITH_BIRTHDATE,
  VALIDATION_CONSTANTS,
} from 'global/constants';
import { NO_SECOND_QUALIFICATION } from 'global/qualifications';

import { areExpertContactsEnabled } from 'utils/FormUtils';
import { YFutureDate, YPastDate, YPhoneNumber } from 'utils/YupUtils';
import { getTenantId } from 'utils/tenantUtil';

export const YNEExpertValidation = (branchSelectionValues) =>
  Yup.object()
    .shape({
      lastName: Yup.string()
        .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
        .max(EIV_CHAR_LENGTH.EXPERT_NAME, VALIDATION_CONSTANTS.TOO_LONG)
        .required(VALIDATION_CONSTANTS.MANDATORY),
      birthdate: Yup.string().when([], {
        is: () => TENANT_WITH_BIRTHDATE.includes(getTenantId()),
        then: YPastDate.required(VALIDATION_CONSTANTS.MANDATORY),
      }),
      firstName: Yup.string()
        .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
        .max(EIV_CHAR_LENGTH.EXPERT_NAME, VALIDATION_CONSTANTS.TOO_LONG)
        .required(VALIDATION_CONSTANTS.MANDATORY),
      netzportalEmail: Yup.string().email(VALIDATION_CONSTANTS.INVALID_EMAIL).optional(),
      telefon: Yup.lazy((value) => {
        if (value !== undefined && value !== '' && areExpertContactsEnabled) {
          return YPhoneNumber;
        }
        return Yup.string().nullable().optional();
      }),
      newEmail: Yup.string().email(VALIDATION_CONSTANTS.INVALID_EMAIL).optional(),
      confirmEmail: Yup.string()
        .optional()
        .when('newEmail', {
          is: (val) => Boolean(val),
          then: (schema) =>
            schema
              .required('Bitte bestätigen Sie die E-Mail-Adresse')
              .oneOf([Yup.ref('netzportalEmail')], 'Die E-Mail-Adressen stimmen nicht überein'),
        }),
      isExpertEnergyActive: Yup.boolean(),
      isExpertGasActive: Yup.boolean(),
      energyValidityDate: Yup.string().when(['isExpertEnergyActive'], {
        is: (isExpertEnergyActive) =>
          branchSelectionValues.branchTypeEnergy === EIV_ENTRY_TYPE.GUEST && isExpertEnergyActive,
        then: YFutureDate.required(VALIDATION_CONSTANTS.MANDATORY),
      }),
      gasValidityDate: Yup.string().when(['isExpertGasActive'], {
        is: (isExpertGasActive) =>
          branchSelectionValues.branchTypeGas === EIV_ENTRY_TYPE.GUEST && isExpertGasActive,
        then: YFutureDate.required(VALIDATION_CONSTANTS.MANDATORY),
      }),
      firstQualificationEnergy: Yup.string().when(['isExpertEnergyActive'], {
        is: (isExpertEnergyActive) =>
          isExpertEnergyActive === true &&
          branchSelectionValues.branchTypeEnergy === EIV_ENTRY_TYPE.MAIN,
        then: (validation) => validation.required(VALIDATION_CONSTANTS.MANDATORY),
      }),
      secondQualificationEnergy: Yup.string().when(
        ['isExpertEnergyActive', 'firstQualificationEnergy'],
        {
          is: (isExpertEnergyActive, firstQualificationEnergy) =>
            isExpertEnergyActive === true &&
            branchSelectionValues.branchTypeEnergy === EIV_ENTRY_TYPE.MAIN &&
            !NO_SECOND_QUALIFICATION.includes(firstQualificationEnergy),
          then: (validation) => validation.required(VALIDATION_CONSTANTS.MANDATORY),
        }
      ),
      firstQualificationGas: Yup.string().when(['isExpertGasActive'], {
        is: (isExpertGasActive) =>
          isExpertGasActive === true && branchSelectionValues.branchTypeGas === EIV_ENTRY_TYPE.MAIN,
        then: (validation) => validation.required(VALIDATION_CONSTANTS.MANDATORY),
      }),

      secondQualificationGas: Yup.string().when(['isExpertGasActive', 'firstQualificationGas'], {
        is: (isExpertGasActive, firstQualificationGas) =>
          isExpertGasActive === true &&
          branchSelectionValues.branchTypeGas === EIV_ENTRY_TYPE.MAIN &&
          !NO_SECOND_QUALIFICATION.includes(firstQualificationGas),
        then: (validation) => validation.required(VALIDATION_CONSTANTS.MANDATORY),
      }),
      isExpertOwner: Yup.boolean().when(['isExpertEnergyActive', 'isExpertGasActive'], {
        is: (isExpertEnergyActive, isExpertGasActive) =>
          (isExpertEnergyActive === true &&
            branchSelectionValues.branchTypeEnergy === EIV_ENTRY_TYPE.MAIN) ||
          (isExpertGasActive === true &&
            branchSelectionValues.branchTypeGas === EIV_ENTRY_TYPE.MAIN),
        then: Yup.boolean().required(VALIDATION_CONSTANTS.MANDATORY),
      }),
    })
    .test('checkAtLeastOneBranchSelected', null, (obj) => {
      if (obj.isExpertEnergyActive || obj.isExpertGasActive) {
        return true; // everything is fine
      }
      return new Yup.ValidationError(
        'Wählen Sie mindestens eine Sparte aus.',
        null,
        'noBranchSelected'
      );
    });
